// extracted by mini-css-extract-plugin
export default {"accountContainer":"style_accountContainer__PZUr1","header":"style_header__rFtiP","body":"style_body__+gM9-","footer":"style_footer__RoERb"};